export default `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 10H20" stroke="#141A77"/>
<path d="M10 20L10 -5.96046e-08" stroke="#141A77"/>
</svg>`
